import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { PerformanceMonitorService } from '../services/performance-monitor.service';

/** Requests slower than this are flagged as slow, even if they eventually succeed. */
const SLOW_REQUEST_THRESHOLD_MS = 3000;

export const performanceInterceptor: HttpInterceptorFn = (req, next) => {
  const monitor = inject(PerformanceMonitorService);
  const start = performance.now();
  let status = 0;

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) status = event.status;
      },
      error: (err: HttpErrorResponse) => {
        status = err.status;
      },
    }),
    finalize(() => {
      const durationMs = performance.now() - start;
      if (durationMs >= SLOW_REQUEST_THRESHOLD_MS) {
        monitor.recordSlowRequest({ url: req.url, method: req.method, durationMs, status });
      }
    }),
  );
};
